import { Controller } from "@hotwired/stimulus"
import { patch } from "@rails/request.js"

// Connects to data-controller="notifications"
export default class extends Controller {
  static values ={
    updateUrl: String,
    notificationId: Number
  }

  markAsRead(event) {
    event.preventDefault()
    event.stopPropagation()

    patch(this.updateUrlValue, {
      body: {
        id: this.notificationIdValue
      },
      responseKind: "turbo-stream"
    })
  }
}
